import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import { RootLayout } from './app/layout/RootLayout';
import { HomePage } from './app/routes/home';
import { OperatorsPage } from './app/routes/operators';
import { FAQPage } from './app/routes/faq';
import { StormPassPage } from './app/routes/storm-pass';
import { ApplyPage } from './app/routes/apply';
import { CityLandingPage } from './app/routes/city';
import { CitiesDirectoryPage } from './app/routes/cities';

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route element={<RootLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/operators" element={<OperatorsPage />} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/storm-pass" element={<StormPassPage />} />
          <Route path="/cities" element={<CitiesDirectoryPage />} />
          <Route path="/cities/:citySlug" element={<CityLandingPage />} />
        </Route>
      </Routes>
      <Analytics />
    </HelmetProvider>
  );
}

export default App;

